<template>
  <div class="project">
    <div class="logo" v-if="logoUrl">
      <a :href="url" target="_blank"><img :src="logoUrl" /></a>
    </div>
    <div class="content">
      <div class="name"><a :href="url" target="_blank">{{name}}</a></div>
      <div class="description">
        <p v-for="(fragment, i) in descriptionMarkup"
           :key="i"
           class="md"
           v-html="fragment"></p>
      </div>
      <div class="launch">Launched <span class="launch_date">{{launchDate}}</span></div>
    </div>
  </div>
</template>

<script>

import MarkdownMixin from '@/mixins/markdown';

export default {
    name   : "Project",
    mixins : [ MarkdownMixin ],
    props  : {
        model : {
            type : Object
        }
    },
    computed : {
        name() {
            return this.model.name;
        },
        description() {
            return this.model.description;
        },
        descriptionMarkup() {
            return this.description.map(text => {
                return this.markdown.renderInline(text.trim());
            });
        },
        url() {
            return this.model.url;
        },
        launchDate() {
            return this.model.launchDate;
        },
        logoUrl() {
            const file = this.model.logoFile;
            if (file) {
                return require(`../../assets/img/${file}`);
            }
            return null;
        }
    }
};

</script>

<style scoped>

.project {
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
}

.project .logo {
    width:160px;
    flex:0 0 auto;
}

.project .logo > a {
    display:inline-block;
    width:100%;
}

.project .logo > a > img {
    max-width:100%;
}

.project .content {
    margin-left:20px;
    color:var(--core-white);
}

.project .content a {
    color:inherit;
}

.project .name {
    font-size:24px;
    font-weight:bold;
}

.project .description {
    font-size:16px;
}

.project .launch {
    color:var(--light-orange);
    font-size:16px;
    font-style:italic;
    margin-top:0.5em;
    text-align:right;
}

.project .launch > .launch_date {
    font-weight:bold;
}

</style>
